// text contents for Privacy.tsx
export const privacy = {
	title: `Privacy Notice`,
	body: `TBD`,
};
